var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('nav-bar-top'),(_vm.account.user_type === 'candidate')?_c('dashboard-candidate'):_vm._e(),(_vm.account.user_type === 'company')?_c('dashboard-company'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }